import * as e from "react";
const l = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 6a3 3 0 013-3h14a3 3 0 013 3v6a1 1 0 11-2 0v-1H4v6a1 1 0 001 1h8.5a1 1 0 110 2H5a3 3 0 01-3-3V6zm18 0v3H4V6a1 1 0 011-1h14a1 1 0 011 1zM6 8a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 100-2 1 1 0 000 2zm9.919 10.804l-2.2-2.2 1.2-.297a.786.786 0 00.08-1.501l-5.091-1.908h-.001a.787.787 0 00-1.007 1.014l1.91 5.089v.001a.786.786 0 001.495-.086l.298-1.195 2.2 2.198a.79.79 0 001.116-1.115z",
      fill: "#2d6ded"
    }
  )
), t = l;
export {
  t as default
};
